import { Navigate } from "react-router-dom";
import { getAuthItem } from "../utils/auth";

// Helper to decode JWT and check client_id
function decodeJwt(token) {
  try {
    if (!token || token === 'null' || token === 'undefined') return null;
    const payload = token.split('.')[1];
    if (!payload) return null;
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch (e) {
    return null;
  }
}

export default function ProtectedClientRoute({ children }) {
  const token = getAuthItem("token");

  // Filter out invalid tokens
  const validToken = token && token !== 'null' && token !== 'undefined' && token.trim() !== '' ? token : null;

  if (!validToken) {
    console.log("ProtectedClientRoute: No valid token found, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // Decode token to get client_id and type
  const tokenPayload = decodeJwt(validToken);
  const clientIdFromToken = tokenPayload?.client_id;
  const userType = tokenPayload?.type || getAuthItem("userType")?.toLowerCase() || '';

  // Also check storage as fallback
  const clientIdFromStorage = getAuthItem("clientId");
  const clientId = clientIdFromToken || clientIdFromStorage;

  // Client dashboard users must have:
  // 1. client_id (not null)
  // 2. type is NOT fieldstaff or outsourcestaff
  const isFieldStaff = userType === 'fieldstaff' || userType === 'outsourcestaff' || userType === 'outsourcedstaff';
  const hasClientId = clientId && clientId !== 'null' && clientId !== 'undefined';

  console.log("ProtectedClientRoute:", {
    hasToken: !!validToken,
    clientIdFromToken,
    clientIdFromStorage,
    clientId,
    userType,
    isFieldStaff,
    hasClientId,
    canAccess: hasClientId && !isFieldStaff
  });

  if (!hasClientId) {
    console.log("ProtectedClientRoute: No client_id found, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  if (isFieldStaff) {
    console.log("ProtectedClientRoute: Field staff cannot access client dashboard, redirecting to availability");
    return <Navigate to="/availability" replace />;
  }

  console.log("ProtectedClientRoute: Access granted");
  return children;
}
